import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class CaptchaToGenerateEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {number} */
		this.count = null;
		/** @type {number} */
		this.captchaType = null;
	}

	/**
	 * @typedef {Object} _CaptchaToGenerateEditDtoProps
	 * @property {number} count
	 * @property {number} captchaType
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaToGenerateEditDtoProps} CaptchaToGenerateEditDtoProps
	 */
	/**
	 *
	 * @param {CaptchaToGenerateEditDtoProps} props
	 * @returns {CaptchaToGenerateEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.count = props.count;
		this.captchaType = props.captchaType;
		return this;
	}
}

export default CaptchaToGenerateEditDto;
